export const GET_PERIOD_REQUEST = 'GET_PERIOD_REQUEST';
export const GET_PERIOD_SUCCESS = 'GET_PERIOD_SUCCESS';
export const GET_PERIOD_FAILURE = 'GET_PERIOD_FAILURE';
